const initialState = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
  page: 0,
  limit: 25,
  searchKey: null,
};

export default initialState;
